/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";
import InputField from "../../shared-ui/input-field";
import Button from "../../shared-ui/button";
import { listTestScenarios } from "../../../services/adminToolServices/getTestListScenarios";
import { filterTestScenario } from "../../../services/adminToolServices/filterTestScenario";
import ReactDOM from "react-dom";
import _, { filter, initial } from "lodash";
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import { handleMetaRecoResultAPIById } from "../../../services/adminToolServices/getMetaRecommendation";
import AdminPopupComponent from "../../shared-ui/popup/admin-popup";
import { formattedText } from "../../../utils/formattedText";
import TestCaseFilterComponent from "./test-case-filter";
import { handleDeleteTestScenarioAPI } from "../../../services/adminToolServices/deleteTestScenario";
import MessageStrip from "../../shared-ui/message-strip";
import { validateAdminOktaSession } from "../../../utils/validateOktaSession";
import ReactTooltip from "react-tooltip";
import BannerError from "../../shared-ui/errors/error-banner";
import Loader from "../../shared-ui/loader";
import { getMasterJsonData } from "../../../utils/scriptLogic";
import { msalInstance } from "../../../core/authentication/entra/msal";
import { signOutAdmin } from "../../../utils/validateAdminSession";

// Interface for Test Case Dashboard State
interface ViewTestCaseState {
  // isRulesVisiable: boolean;
  testScenarioList: any;
  isMenuOpen: boolean;
  isSorted: any;
  initialTestList: any;
  isTagsFilterOpen: boolean;
  selectedFilterValues: any;
  isApplyFilter: boolean;
  valueToSearch: string;
  filteredTestList: any;
  isPopUpShow: boolean;
  test_id: any;
  user: any;
  isOpenMessageStrip: boolean;
  updateList: boolean;
  isListLoader: boolean;
  isJsonRecieved: boolean;
  isSearch: boolean;
  isMenu: boolean;
  testScenarioListCopy: any;
  isApiFailed: boolean;
  ApiFailedMessage: string;
}

class ViewTestCase extends React.Component<any, ViewTestCaseState> {
  node: any;
  constructor(props: any) {
    super(props);
    this.state = {
      // isRulesVisiable: false,
      testScenarioList: [],
      isMenuOpen: false,
      isSorted: {
        test_id: false,
        version: false,
        creator: false,
        user: false,
        modified_date: false,
      },
      initialTestList: [],
      isTagsFilterOpen: false,
      selectedFilterValues: [],
      isApplyFilter: false,
      valueToSearch: "",
      filteredTestList: [],
      isPopUpShow: false,
      test_id: "",
      user: "",
      isOpenMessageStrip: false,
      updateList: false,
      isListLoader: false,
      isJsonRecieved: false,
      isSearch: false,
      isMenu: false,
      testScenarioListCopy: {},
      isApiFailed: false,
      ApiFailedMessage: "",
    };
  }

  componentDidUpdate = () => {
    const accounts = msalInstance.getAllAccounts();
    if (!accounts || accounts.length === 0) {
      signOutAdmin();
      return;
    }

    const { updateList } = this.state;
    if (updateList) {
      this.setState(
        {
          updateList: false,
        },
        () => {
          this.getTestList();
        }
      );
    }
    if (this.state.isMenu) {
      const { testScenarioList } = this.state;
      let testList = testScenarioList;
      testList.map((item: any) => {
        if (item.isMenuOpen) {
          const concernedElement: Element | any =
            document.querySelector(".three-dot-icon");

          document.addEventListener("click", (event) => {
            if (!concernedElement?.contains(event.target)) {
              item.isMenuOpen = false;
              this.setState({
                isMenu: false,
              });
            }
          });
        }
      });
    }
  };

  /**
   * This method is used to handleTestList API
   *
   */
  getTestList = () => {
    this.setState({
      isListLoader: true,
    });
    listTestScenarios(this.props).then((res: any) => {
      if (res?.error === true) {
        this.setState(
          {
            isApiFailed: true,
            ApiFailedMessage: res?.message,
            isListLoader: false,
          },
          () => {
            setTimeout(() => {
              this.setState({
                isApiFailed: false,
                ApiFailedMessage: "",
              });
            }, 3000);
          }
        );
      } else {
        let groupedArr = _.groupBy(res?.data?.listTestScenario, "test_id");
        let sortedGroup = _.map(
          Object.keys(groupedArr),
          (obj: any, index: number) => {
            let group = _.reverse(groupedArr[`${obj}`]);
            let g: any = _.remove(group.slice(1), function (element) {
              return element?.version !== 0;
            });

            let Obj: any = {};
            Obj = group[0];
            Obj.test_id_main = group[0].test_id;
            Obj.test_id = group[0].test_id.toLowerCase();
            Obj.isDisabled = false;
            Obj.isMenuOpen = false;
            Obj.previousVersions = g;
            return Obj;
          }
        );

        this.setState({
          isListLoader: false,
          testScenarioList: _.sortBy(sortedGroup, "modified_date").reverse(),
        });
      }
    });
  };
  componentDidMount = async () => {
    const accounts = msalInstance.getAllAccounts();
    if (!accounts || accounts.length === 0) {
      signOutAdmin();
      return;
    }
    
    const masterJsonData = localStorage.getObj("masterJson");
    if (masterJsonData !== undefined && !_.isEmpty(masterJsonData)) {
      this.setState(
        {
          isJsonRecieved: true,
        },
        () => {
          this.getTestList();
        }
      );
    } else {
      await getMasterJsonData(async (res: any) => {
        this.setState(
          {
            isJsonRecieved: true,
          },
          () => {
            localStorage.setObj("masterJson", res);
            this.getTestList();
          }
        );
      });
    }
    const { location, history } = this.props;
    if (this.props?.history?.location?.state) {
      let stripMessage = this.props?.history?.location?.state;
      this.setState(
        {
          isOpenMessageStrip: stripMessage,
        },
        () => {
          setTimeout(() => {
            this.setState({
              isOpenMessageStrip: false,
            });
          }, 3000);
        }
      );
    }
    history.replace();
  };

  handleMenuOpen = (test_id: string, e?: any) => {
    const { testScenarioList } = this.state;
    let testList = testScenarioList;
    testList.map((item: any) => {
      if (item?.test_id === test_id) {
        item.isMenuOpen = !item.isMenuOpen;
        this.setState({
          testScenarioList: testList,
          isMenu: !this.state.isMenu,
        });
      } else {
        item.isMenuOpen = false;
      }
    });
    e?.stopPropagation();
  };

  handleViewTestCase = (test_id_main: any, user?: string, creator?: string) => {
    handleMetaRecoResultAPIById(test_id_main, this.props).then((res: any) => {
      if (res?.error === true) {
        this.setState(
          {
            isApiFailed: true,
            ApiFailedMessage: res?.message,
          },
          () => {
            setTimeout(() => {
              this.setState({
                isApiFailed: false,
                ApiFailedMessage: "",
              });
            }, 3000);
          }
        );
      } else {
        let recoOutput: any = res?.data?.getMetaRecommendationById?.output;
        let inputs: any = res?.data?.getMetaRecommendationById?.inputs;
        const parsedInputs: any = inputs && JSON.parse(inputs);

        this.props.history.push({
          pathname: "/admin/dashboard",
          state: {
            test_id: test_id_main,
            user: user,
            creator: creator,
            initialInput: parsedInputs,
            initialOutput: recoOutput,
          },
        });
      }
    });
  };

  /**
   * This method is used to delete test case
   *
   */
  handleDeleteTestCase = () => {
    const { test_id, user } = this.state;
    let deleteTestCaseObj: any = {};
    deleteTestCaseObj["test_id"] = test_id;
    deleteTestCaseObj["user"] = user;
    const data = handleDeleteTestScenarioAPI(deleteTestCaseObj, this.props);
    data.then((response: any) => {
      if (response?.error === true) {
        this.setState(
          {
            isApiFailed: true,
            isPopUpShow: false,
            ApiFailedMessage: response?.message,
          },
          () => {
            setTimeout(() => {
              this.setState({
                isApiFailed: false,
                ApiFailedMessage: "",
              });
            }, 3000);
          }
        );
      } else {
        response.status === 200 && this.getTestList();
        this.setState(
          {
            isPopUpShow: false,
            isOpenMessageStrip: true,
            updateList: true,
          },
          () => {
            this.handleMenuOpen(test_id);
            setTimeout(() => {
              this.setState({
                isOpenMessageStrip: false,
              });
            }, 3000);
          }
        );
      }
    });
  };

  handleVersionClick = (index: number) => {
    const { testScenarioList } = this.state;
    let data = testScenarioList;
    data?.slice(index, 0, data[index]?.previousVersions);
  };

  handleCreateNewTestCase = () => {
    localStorage.removeItem("isEdit");
    localStorage.removeItem("meta_result");
    localStorage.removeItem("answersObj");
    localStorage.removeItem("testCaseName");
    this.props.history.push("/admin/dashboard");
  };

  handleSorting = (test_id: string) => {
    const { isSorted } = this.state;
    if (isSorted[`${test_id}`]) {
      this.setState({
        testScenarioList: this.state.testScenarioList.reverse(),
        filteredTestList: this.state.filteredTestList.reverse(),
      });
    } else {
      this.setState({
        testScenarioList: _.sortBy(this.state.testScenarioList, `${test_id}`),
        filteredTestList: _.sortBy(this.state.filteredTestList, `${test_id}`),
      });
    }
    Object.keys(isSorted).map((obj: any) => {
      if (obj === test_id) {
        isSorted[`${test_id}`] = !isSorted[`${test_id}`];
      } else {
        isSorted[`${obj}`] = false;
      }
    });
  };

  handleFilterPopup = (condition: boolean) => {
    this.setState({
      isTagsFilterOpen: condition,
      // isApplyFilter: false
    });
  };

  handleApplyFilter = (filterSelectedValue: any) => {
    // filterTestScenario().then((res: any){ console.log("resp--->",res))}
    // const { selectedFilterValues } = this.state
    // this.setState({
    //   isApplyFilter: true
    // })
    this.setState({
      selectedFilterValues: filterSelectedValue,
      isListLoader: true,
    });
    filterTestScenario(filterSelectedValue, this.props).then((res: any) => {
      if (res?.error === true) {
        this.setState(
          {
            isApiFailed: true,
            isPopUpShow: false,
            ApiFailedMessage: res?.message,
          },
          () => {
            setTimeout(() => {
              this.setState({
                isApiFailed: false,
                ApiFailedMessage: "",
              });
            }, 3000);
          }
        );
      } else {
        this.setState({
          isListLoader: false,
          filteredTestList: res?.data?.filterTestScenario,
        });
      }
    });
  };

  handleCheckboxvalue = (value: any) => {};

  handleRemoveTag = (removeVal: any) => {
    const { selectedFilterValues } = this.state;
    const updatedFilterValues = selectedFilterValues.filter(
      (val: any) => val !== removeVal
    );
    this.setState(
      {
        isListLoader: true,
        selectedFilterValues: updatedFilterValues,
      },
      () => {
        filterTestScenario(this.state.selectedFilterValues, this.props).then(
          (res: any) => {
            if (res?.error === true) {
              this.setState(
                {
                  isApiFailed: true,
                  isPopUpShow: false,
                  ApiFailedMessage: res?.message,
                },
                () => {
                  setTimeout(() => {
                    this.setState({
                      isApiFailed: false,
                      ApiFailedMessage: "",
                    });
                  }, 3000);
                }
              );
            } else {
              this.setState({
                isListLoader: false,
                filteredTestList: res?.data?.filterTestScenario,
              });
            }
          }
        );
      }
    );
  };

  handleClearAllFilter = () => {
    this.setState(
      {
        selectedFilterValues: [],
      },
      () => {
        this.getTestList();
      }
    );
  };

  handleSearch = (valueToSearch: any, testScenarioList1: any) => {
    const { testScenarioList } = this.state;
    this.setState({
      valueToSearch: valueToSearch,
    });
    if (valueToSearch.length > 0) {
      this.setState({
        isSearch: true,
      });
    } else {
      this.setState({
        isSearch: false,
      });
    }
  };
  handleCross = (e: any) => {
    if (this.state.isSearch) {
      this.setState({
        valueToSearch: "",
      });
    }
    this.setState({
      isSearch: false,
    });
  };
  handleClose = () => {
    this.setState({
      isPopUpShow: false,
      isMenuOpen: false,
    });
  };

  render() {
    const {
      testScenarioList,
      isMenuOpen,
      isSorted,
      filteredTestList,
      valueToSearch,
      isPopUpShow,
      isOpenMessageStrip,
      isTagsFilterOpen,
      selectedFilterValues,
      isApplyFilter,
      isListLoader,
      isSearch,
      isJsonRecieved,
      isApiFailed,
    } = this.state;
    let temp: any =
      selectedFilterValues.length > 0 ||
      (valueToSearch.trim().length > 1 && selectedFilterValues.length > 0)
        ? filteredTestList
        : testScenarioList;

    let testListToDisplay: any;

    testListToDisplay =
      valueToSearch.trim().length > 1
        ? temp?.filter((item: any) =>
            item?.test_id
              ?.replaceAll("_", " ")
              ?.replaceAll("-", " ")
              .toLowerCase()
              ?.trim()
              ?.includes(
                valueToSearch
                  ?.replaceAll("_", " ")
                  ?.replaceAll("-", " ")
                  ?.trim()
              )
          )
        : temp;
    return (
      <div className="view-test-container">
        {/* Test Case Filter Popup Start */}
        {isTagsFilterOpen && (
          <TestCaseFilterComponent
            show={isTagsFilterOpen}
            handleClose={() => this.handleFilterPopup(false)}
            handleApplyFilter={(onChangeselectedValue: any) =>
              this.handleApplyFilter(onChangeselectedValue)
            }
            handleCheckboxvalue={(val: any) => this.handleCheckboxvalue(val)}
            filterSelectedValue={selectedFilterValues}
          />
        )}
        {/* Test Case Filter Popup Ends */}
        {/* <div className="title">Test Cases</div> */}

        {/* Delete Popup Start */}
        {isPopUpShow && (
          <AdminPopupComponent
            open={isPopUpShow}
            close={this.handleClose}
            onDelete={this.handleDeleteTestCase}
            buttonName={"Delete"}
            cancleButtonName={"Cancel"}
            heading={"Hold on"}
            title={
              "Are you sure you want to delete this Test Case? This will also delete all its previous versions as well."
            }
          />
        )}
        {/* Delete Admin Popup End */}
        {this.state.isApiFailed && (
          <MessageStrip
            error
            messageText={this.state.ApiFailedMessage || "Something went wrong. Try again or start over"}
          />
        )}
        {/* Test Case Deleted Message Starts */}
        {isOpenMessageStrip ? (
          <MessageStrip messageText={"The Test Case has been deleted"} />
        ) : null}
        {/* Test Case Deleted Message Ends */}

        <div className="view-test-cases-wrapper">
          <div className="filter-wrapper">
            <div className="main-input">
              <div className="title">Test Cases</div>
              <div className="search-wrapper">
                <InputField
                  type={"text"}
                  placeHolder={"Search test name"}
                  className={"custom-input"}
                  handleInputChange={(e) => {
                    this.handleSearch(
                      e.target.value.toLowerCase(),
                      testListToDisplay
                    );
                  }}
                  inputValue={_.capitalize(this.state.valueToSearch)}
                  autoFocusOnInput
                />
                <div
                  className={isSearch ? "icon cross-icon" : "icon search-icon"}
                  onClick={(e) => this.handleCross(e)}
                ></div>
              </div>
              <div
                className="icon filter-icon"
                onClick={() => this.handleFilterPopup(true)}
              ></div>
            </div>
            <div className={isJsonRecieved ? "create-test-case-btn" : "hide"}>
              {/* <div className="filter-btn-area">Filter</div> */}
              <Button
                onButtonClick={() => this.handleCreateNewTestCase()}
                name={"Create Test Case"}
                className={"app-btn admin-btn"}
              />
            </div>
          </div>
          {/* Tags container start */}
          {selectedFilterValues && selectedFilterValues.length > 0 && (
            <div className="filter-tags">
              <div className={"tags-container"}>
                <div className="tags-wrapper">
                  <div className="tags-list">
                    {selectedFilterValues.map((item: any) => (
                      <div className="tags">
                        <span className="label">{item}</span>
                        <span
                          tabIndex={0}
                          role="button"
                          aria-label="cross button for dis-select"
                          className="icon cross-icon"
                          onClick={() => this.handleRemoveTag(item)}
                          onKeyPress={(e: any) => {
                            if (e.key === "Enter" || e.key === " ") {
                            }
                          }}
                        ></span>
                      </div>
                    ))}
                    {selectedFilterValues.length > 1 && (
                      <div
                        className="clear-filter"
                        onClick={() => this.handleClearAllFilter()}
                      >
                        Clear All Filters
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* Tags container Ends */}
          <div className="table-view-test-cases">
            <div className="table-container sales-list-tbl">
              {/* Table Header Starts */}
              <div className="tbl-head-section">
                <div className="table-head">
                  <div
                    className="heading"
                    onClick={() => this.handleSorting("test_id")}
                  >
                    <div className="text">
                      Name{" "}
                      <span
                        className={
                          isSorted[`${"test_id"}`]
                            ? "icon arrow-up"
                            : "icon arrow-down"
                        }
                      ></span>
                    </div>
                  </div>
                  <div className="heading">
                    <div className="text">Version </div>
                  </div>
                  <div
                    className="heading"
                    onClick={() => this.handleSorting("creator")}
                  >
                    <div className="text">
                      Creator{" "}
                      <span
                        className={
                          isSorted[`${"creator"}`]
                            ? "icon arrow-up"
                            : "icon arrow-down"
                        }
                      ></span>
                    </div>
                  </div>
                  <div
                    className="heading"
                    onClick={() => this.handleSorting("user")}
                  >
                    <div className="text">
                      Last edit by{" "}
                      <span
                        className={
                          isSorted[`${"user"}`]
                            ? "icon arrow-up"
                            : "icon arrow-down"
                        }
                      ></span>
                    </div>
                  </div>
                  <div
                    className="heading"
                    onClick={() => this.handleSorting("modified_date")}
                  >
                    <div className="text">
                      Last edited
                      <span
                        className={
                          isSorted[`${"modified_date"}`]
                            ? "icon arrow-up"
                            : "icon arrow-down"
                        }
                      ></span>
                    </div>
                  </div>
                  <div className="heading">
                    <div className="text">Filters</div>
                  </div>
                  <div className="heading">
                    <div className="text"></div>
                  </div>
                </div>
              </div>
              {/* Table Header Ends */}

              {/* Table Body Starts */}
              {isListLoader || !isJsonRecieved ? (
                <Loader loaderClassName={"loader-wrapper align-middle"} />
              ) : testListToDisplay?.length > 0 ? (
                <Accordion allowZeroExpanded={true}>
                  <div className="tbl-body-section">
                    {testListToDisplay.map((item: any, index: number) => (
                      <AccordionItem>
                        <div className="tbl-row">
                          <div
                            className="inner-wrapper"
                            onClick={() => {
                              this.handleViewTestCase(
                                selectedFilterValues?.length > 0
                                  ? item?.test_id
                                  : item?.test_id_main,
                                item?.user,
                                item?.creator
                              );
                            }}
                          >
                            <div
                              className="heading ellipsis"
                              data-tip
                              data-for={item.test_id}
                            >
                              {/* {detail.fiscalMonth} */}
                              {formattedText(
                                item?.test_id.replaceAll("_", " ")
                              )}
                              {item?.test_id.length > 33 ? (
                                <ReactTooltip
                                  id={item.test_id.toString()}
                                  place="bottom"
                                  type="dark"
                                  effect="solid"
                                  multiline={true}
                                >
                                  {formattedText(
                                    item?.test_id.replaceAll("_", " ")
                                  )}
                                </ReactTooltip>
                              ) : null}
                            </div>
                          </div>

                          <div className="inner-wrapper">
                            <AccordionItemButton>
                              <div
                                className="heading ellipsis"
                                onClick={() => this.handleVersionClick(index)}
                              >
                                {/* {detail.fiscalMonth} */}
                                {item?.version !== 0
                                  ? `Version ${item?.version}`
                                  : "Latest"}
                                {item?.previousVersions?.length > 0 && (
                                  <span className="icon arrow-down"></span>
                                )}
                              </div>
                            </AccordionItemButton>
                          </div>
                          <div className="inner-wrapper">
                            <div className="heading ellipsis">
                              {/* {detail.fiscalMonth} */}
                              {formattedText(
                                item?.creator
                                  .replace(/@[^@]+$/, "")
                                  .replaceAll(".", " ")
                              )}
                            </div>
                          </div>
                          <div className="inner-wrapper">
                            <div className="heading ellipsis">
                              {/* {detail.fiscalMonth} */}
                              {formattedText(
                                item?.user
                                  .replace(/@[^@]+$/, "")
                                  .replaceAll(".", " ")
                              )}
                            </div>
                          </div>
                          <div className="inner-wrapper">
                            <div className="heading ellipsis">
                              {/* {detail.fiscalMonth} */}
                              {item?.modified_date !== "" &&
                                new Date(item?.modified_date)
                                  ?.toLocaleString("en-US")
                                  .slice(0, 10)
                                  .replaceAll("-", "/")}
                            </div>
                          </div>
                          <div className="inner-wrapper">
                            <div
                              className="heading ellipsis"
                              data-tip
                              data-for={index}
                            >
                              {(item?.tags).toString().replace(/,/g, ", ")}
                              <ReactTooltip
                                id={index.toString()}
                                place="bottom"
                                type="dark"
                                effect="solid"
                                multiline={true}
                              >
                                {(item?.tags).toString().replace(/,/g, ", ")}
                              </ReactTooltip>
                            </div>
                          </div>
                          <div className="inner-wrapper">
                            <div
                              className="three-dot-icon icon"
                              onClick={(e: any) =>
                                this.handleMenuOpen(item?.test_id, e)
                              }
                            ></div>
                            <div
                              className={
                                item?.isMenuOpen
                                  ? "options-view"
                                  : "options-view hide"
                              }
                            >
                              <div
                                className="option"
                                onClick={() => {
                                  this.handleViewTestCase(
                                    selectedFilterValues?.length > 0
                                      ? item?.test_id
                                      : item?.test_id_main,
                                    item?.user,
                                    item?.creator
                                  );
                                }}
                              >
                                View
                              </div>
                              <div
                                className="option"
                                onClick={() => {
                                  //this.handleDeleteTestCase(item?.test_id, item?.user);
                                  this.setState({
                                    isPopUpShow: true,
                                    test_id: item?.test_id_main,
                                    user: item?.user,
                                  });
                                }}
                              >
                                Delete
                              </div>
                            </div>
                          </div>
                        </div>
                        <AccordionItemPanel>
                          {item?.previousVersions &&
                            item?.previousVersions?.length > 0 &&
                            item?.previousVersions.map((obj: any) => (
                              <div className="tbl-row sub-tbl-row">
                                <div className="inner-wrapper">
                                  <div className="sub-heading ellipsis">
                                    {/* {detail.fiscalMonth} */}
                                    {formattedText(
                                      obj?.test_id.replaceAll("_", " ")
                                    )}
                                  </div>
                                </div>

                                <div className="inner-wrapper">
                                  <div
                                    className="sub-heading ellipsis"
                                    onClick={() =>
                                      this.handleVersionClick(index)
                                    }
                                  >
                                    {/* {detail.fiscalMonth} */}
                                    {obj?.version !== 0
                                      ? `Version ${obj?.version}`
                                      : "Latest"}
                                    {/* <span className="icon arrow-down"></span> */}
                                  </div>
                                </div>
                                <div className="inner-wrapper">
                                  <div className="sub-heading ellipsis">
                                    {/* {detail.fiscalMonth} */}
                                    {formattedText(
                                      obj?.creator
                                        .replace(/@[^@]+$/, "")
                                        .replaceAll(".", " ")
                                    )}
                                  </div>
                                </div>
                                <div className="inner-wrapper">
                                  <div className="sub-heading ellipsis">
                                    {/* {detail.fiscalMonth} */}
                                    {formattedText(
                                      obj?.user
                                        .replace(/@[^@]+$/, "")
                                        .replaceAll(".", " ")
                                    )}
                                  </div>
                                </div>
                                <div className="inner-wrapper">
                                  <div className="sub-heading ellipsis">
                                    {/* {detail.fiscalMonth} */}
                                    {obj?.modified_date !== "" &&
                                      new Date(obj?.modified_date)
                                        ?.toLocaleString("en-US")
                                        .slice(0, 10)
                                        .replaceAll("-", "/")}
                                  </div>
                                </div>
                                <div className="inner-wrapper">
                                  <div className="sub-heading ellipsis">
                                    {/* {detail.fiscalMonth} */}
                                    {(obj?.tags).toString()}
                                  </div>
                                </div>
                                <div className="inner-wrapper"></div>
                              </div>
                            ))}
                        </AccordionItemPanel>
                      </AccordionItem>
                    ))}
                  </div>
                </Accordion>
              ) : (
                <div className="no-test-case-found">
                  {valueToSearch?.length > 0
                    ? `No results for “${valueToSearch}”`
                    : "No results"}
                </div>
              )}
              {/* Table Body Ends */}
            </div>
            {/* Table Section Ends */}
          </div>
        </div>
      </div>
    );
  }
}

export default ViewTestCase;
